import React from "react"
import PropTypes from "prop-types"
import ReactApexChart from "react-apexcharts"
import { getChartColorsArray } from "utils/chartColors"
import { ApexOptions } from "apexcharts"

const StackedColumnChart = ({
  periodData,
  category,
}: {
  periodData: any
  category: string[]
}) => {
  const dataColors = ["--bs-success", "--bs-secondary"]
  const stackedColumnChartColors = getChartColorsArray(dataColors)
  const options: ApexOptions = {
    chart: {
      stacked: true,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: !0,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "15%",
        // endingShape: "rounded"
      },
    },
    dataLabels: {
      enabled: !1,
    },
    xaxis: {
      categories: category,
      labels: {
        show: true,
      },
    },
    colors: stackedColumnChartColors,
    legend: {
      position: "bottom",
    },
    fill: {
      opacity: 1,
    },
  }
  return (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={[...periodData]}
        type="bar"
        height="359"
        className="apex-charts"
      />
    </React.Fragment>
  )
}

StackedColumnChart.propTypes = {
  periodData: PropTypes.any,
}
export default StackedColumnChart
